import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import "./App.css";

import { Content } from "./Components/Content/index";
import { RoutesR } from "./Components/Routes";

function App() {
  return (
    <div>
      <Content />
    </div>
  );
}

export default App;
